module.exports = __webpack_public_path__ + "static/media/sf-test-10.49b5ed99.mp3";